import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RampRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ramp_right"}/>
}
